// extracted by mini-css-extract-plugin
module.exports = {"section16":"Section16_section16__ORivJ"};